import './delay_render_chart_view.js.coffee';# Added by Script 
Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.ManagementTypesChartView extends CustomerVisualMode.Charts.DelayRenderChartView
  template: JST['backbone/templates/customer_visual_mode/charts/management_types_chart']
  className: 'grid-item full-width-chart management_types'
  @NAME: 'management_type_percentages'

  initialize: ({widget, data, session, isReadOnly, isResponsive}) ->
    title = I18n.t('customer_visual_mode.charts.management_types.title')
    description = I18n.t('customer_visual_mode.charts.management_types.description')
    times = data.histogram.map((value) -> value.time)
    series = @_createSeries(data)
    @timelineChart = new CustomerVisualMode.Charts.TimelineChartView({
      times,
      series,
      chartOptions: @_chartOptions()
    })
    @dateRangeBuilder = new Common.Dashboard.Filters.DateRangeBuilder(session)
    super({widget, title, description, data, session, isReadOnly, isResponsive})

  render: ->
    super()
    @$el.find('.chart').html(@template)
    @listenTo(@timelineChart, 'timeline:click:line', @_openDrilldown)
    @$el.find('.histogram').append(@timelineChart.render().el)
    @_managementTypeCardViews().forEach((view) =>
      @$('.blocks').append(view.render().el)
      @listenTo(view, 'ticketCountCard:click', @_openDrilldown))
    @

  _renderChart: ->
    @chart = @timelineChart.renderChart()

  _managementTypeCardViews: ->
    [
      @_initialMetricView()
      @_botMetricView()
      @_mixedMetricView()
    ]

  _initialMetricView: ->
    @initialMetricView ||= new CustomerVisualMode.Charts.TicketCountCardView(
      count: "#{@data.total.initial}%"
      clickable: not @isReadOnly
      id: 'initial'
      title: I18n.t('customer_visual_mode.charts.management_types.initial')
    )

  _botMetricView: ->
    @botMetricView ||= new CustomerVisualMode.Charts.TicketCountCardView(
      count: "#{@data.total.bot}%"
      clickable: not @isReadOnly
      id: 'bot'
      title: I18n.t('customer_visual_mode.charts.management_types.bot')
    )

  _mixedMetricView: ->
    @mixedMetricView ||= new CustomerVisualMode.Charts.TicketCountCardView(
      count: "#{@data.total.mixed}%"
      clickable: not @isReadOnly
      id: 'mixed'
      title: I18n.t('customer_visual_mode.charts.management_types.mixed')
    )

  _createSeries: (data) ->
    seriesNames = {
      initial: I18n.t('customer_visual_mode.charts.management_types.initial'),
      bot: I18n.t('customer_visual_mode.charts.management_types.bot'),
      mixed: I18n.t('customer_visual_mode.charts.management_types.mixed')
    }
    dataNames = ['initial', 'bot', 'mixed']
    dataNames.map((dataName) ->
      {
        name: seriesNames[dataName],
        data: data.histogram.map((value) -> {
          y: value[dataName],
          id: dataName,
          time: value.time
        })
      }
    )

  _chartOptions: ->
    {
      colors: ['#f39114', '#80699b', '#4572a7'],
      yAxis:
        labels:
          format: '{value}%'
      tooltip:
        valueSuffix: '%'
    }

  _openDrilldown: (drilldownValue, timeInSeconds) ->
    data = {
      date: @dateRangeBuilder.build(timeInSeconds),
      dimensions: ['custom_attribute'],
      values: [drilldownValue],
      name: 'Management type',
      definition_code: 'management_type',
      drilldown_code: 'created_conversations',
      timezone: moment().format('Z')
    }
    super(data)
